export default __webpack_public_path__ + "static/media/dimi-founder.b354a3f1.png";